import React from 'react';
import clsx from 'clsx';

type Variant = 'primary' | 'secondary' | 'ghost' | 'outline' | 'destructive';
export type Size = 'sm' | 'md' | 'lg';

type Props = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: Variant;
  size?: Size;
  block?: boolean;
};

const base = 'inline-flex items-center justify-center gap-2 whitespace-nowrap font-medium transition active:scale-[0.99] focus:outline-none focus:ring-2 focus:ring-[color:var(--ui2-primary)]/30 disabled:opacity-50 disabled:cursor-not-allowed';

const sizes: Record<Size, string> = {
  sm: 'h-9 px-3 rounded-xl text-xs lg:text-sm',
  md: 'h-10 px-4 rounded-xl text-sm lg:text-base',
  lg: 'h-12 px-5 rounded-2xl text-base lg:text-lg',
};

const variants: Record<Variant, string> = {
  primary: 'bg-[color:var(--ui2-primary)] text-[color:var(--ui2-primary-fg)] shadow-sm hover:brightness-[0.97] hover:shadow-md',
  secondary: 'bg-[color:var(--ui2-text)] text-[color:var(--ui2-primary-fg)] shadow-sm hover:brightness-[0.97]',
  outline: 'border border-[color:var(--ui2-border)] bg-[color:var(--ui2-surface)] text-[color:var(--ui2-text)] hover:brightness-[0.98]',
  ghost: 'text-[color:var(--ui2-text)] hover:bg-black/5',
  destructive: 'bg-[color:var(--ui2-danger)] text-white hover:brightness-[0.97]',
};

export function Button({ variant = 'primary', size = 'md', block, className, ...props }: Props) {
  return (
    <button className={clsx(base, sizes[size], variants[variant], block && 'w-full', className)} {...props} />
  );
}

export default Button;
